import { render, staticRenderFns } from "./SelectButtons.vue?vue&type=template&id=b56e7fa4&scoped=true&"
import script from "./SelectButtons.vue?vue&type=script&lang=js&"
export * from "./SelectButtons.vue?vue&type=script&lang=js&"
import style0 from "./SelectButtons.vue?vue&type=style&index=0&id=b56e7fa4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b56e7fa4",
  null
  
)

export default component.exports